// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OX1O","content":"styles_content__1uYYW","tableWrap":"styles_tableWrap__2iGSx"};